var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.92 12.992c-0.543 0.57-1.065 1.102-1.594 1.626l-0.006 0.006c-1.44 1.408-2.912 2.848-4.384 4.256-0.224 0.224-0.448 0.448-0.672 0.704-0.096 0.096-0.128 0.256-0.128 0.384 0.544 3.168 1.088 6.304 1.632 9.472v0.064c-0.032 0.032-0.16-0.032-0.32-0.128-0.996-0.49-1.541-0.778-2.082-1.072l0.418 0.208c-2.208-1.152-4.416-2.336-6.624-3.488-0.192-0.096-0.32-0.064-0.48 0.032-2.752 1.44-5.504 2.912-8.288 4.352-0.034 0.033-0.078 0.055-0.127 0.064l-0.001 0c-0.096 0.032-0.128-0.064-0.096-0.256 0.128-0.736 0.224-1.472 0.352-2.208 0.416-2.368 0.832-4.736 1.216-7.104 0.032-0.096-0.032-0.256-0.128-0.352-1.44-1.408-2.88-2.784-4.288-4.224-0.771-0.749-1.502-1.521-2.201-2.322l-0.039-0.046c-0.128-0.128-0.096-0.256 0.096-0.288 0.384-0.064 0.832-0.128 1.28-0.192 1.92-0.288 3.872-0.544 5.792-0.832 0.64-0.096 1.312-0.224 1.952-0.288 0.256-0.032 0.352-0.128 0.48-0.352 3.915-8.453 5.273-11.161 6.642-13.862l-2.578 5.606c0.032-0.064 0.064-0.096 0.096-0.16 0.032-0.096 0.128-0.128 0.192-0.032 0.033 0.034 0.055 0.078 0.064 0.127l0 0.001 4.128 8.352c0.078 0.178 0.247 0.304 0.446 0.32l0.002 0c2.848 0.416 5.664 0.832 8.512 1.248 0.224 0.032 0.416 0.064 0.64 0.096 0.192 0 0.224 0.128 0.096 0.288z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCast);
export default __webpack_public_path__ + "static/media/cast.ebab73fdfb8cfe71ee4eef74b6375cd0.svg";
export { ForwardRef as ReactComponent };